import React from "react";
import PropTypes from "prop-types";

import Picks from "./Picks";
import { TeamShape } from "./nfl";
import { FONT_LEAGUE } from "./styles";

const TABLE_STYLE = Object.assign(
  {
    margin: "30px auto 0",
    borderCollapse: "collapse",
    textAlign: "center",
    fontSize: 24,
    minWidth: 320,
  },
  FONT_LEAGUE,
);

const CELL_STYLE = {
  padding: "6px 12px",
};

const HEAD_STYLE = Object.assign(
  {
    color: "#aaa",
    borderBottom: "1px solid #333",
  },
  CELL_STYLE,
);

const BODY_STYLE = Object.assign(
  {
    borderBottom: "1px solid #333",
  },
  CELL_STYLE,
);

function valueAt(periods, index) {
  if (!periods || periods.length <= index) {
    return null;
  }
  return periods[index];
}

function finalValue(periods) {
  if (!periods || periods.length < 4) {
    return null;
  }
  return periods[periods.length - 1];
}

function formatScore(score) {
  return score === null || score === undefined ? "" : score;
}

function winnerShort(picks, awayScore, homeScore) {
  if (awayScore === null || awayScore === undefined || homeScore === null || homeScore === undefined) {
    return "";
  }
  const winner = picks.winnerAt(awayScore, homeScore);
  return winner ? winner.shortName : "";
}

function QuarterSummary({ picks, away, home, awayPeriods, homePeriods }) {
  const awayQ1 = valueAt(awayPeriods, 0);
  const awayQ2 = valueAt(awayPeriods, 1);
  const awayQ3 = valueAt(awayPeriods, 2);
  const awayFinal = finalValue(awayPeriods);

  const homeQ1 = valueAt(homePeriods, 0);
  const homeQ2 = valueAt(homePeriods, 1);
  const homeQ3 = valueAt(homePeriods, 2);
  const homeFinal = finalValue(homePeriods);

  return (
    <table style={TABLE_STYLE}>
      <thead>
        <tr>
          <th style={HEAD_STYLE}>Team</th>
          <th style={HEAD_STYLE}>1</th>
          <th style={HEAD_STYLE}>2</th>
          <th style={HEAD_STYLE}>3</th>
          <th style={HEAD_STYLE}>F</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={BODY_STYLE}>{away.short}</td>
          <td style={BODY_STYLE}>{formatScore(awayQ1)}</td>
          <td style={BODY_STYLE}>{formatScore(awayQ2)}</td>
          <td style={BODY_STYLE}>{formatScore(awayQ3)}</td>
          <td style={BODY_STYLE}>{formatScore(awayFinal)}</td>
        </tr>
        <tr>
          <td style={BODY_STYLE}>{home.short}</td>
          <td style={BODY_STYLE}>{formatScore(homeQ1)}</td>
          <td style={BODY_STYLE}>{formatScore(homeQ2)}</td>
          <td style={BODY_STYLE}>{formatScore(homeQ3)}</td>
          <td style={BODY_STYLE}>{formatScore(homeFinal)}</td>
        </tr>
        <tr>
          <td style={CELL_STYLE} />
          <td style={CELL_STYLE}>{winnerShort(picks, awayQ1, homeQ1)}</td>
          <td style={CELL_STYLE}>{winnerShort(picks, awayQ2, homeQ2)}</td>
          <td style={CELL_STYLE}>{winnerShort(picks, awayQ3, homeQ3)}</td>
          <td style={CELL_STYLE}>{winnerShort(picks, awayFinal, homeFinal)}</td>
        </tr>
      </tbody>
    </table>
  );
}

QuarterSummary.propTypes = {
  picks: PropTypes.instanceOf(Picks).isRequired,
  away: TeamShape.isRequired,
  home: TeamShape.isRequired,
  awayPeriods: PropTypes.array,
  homePeriods: PropTypes.array,
};

QuarterSummary.defaultProps = {
  awayPeriods: null,
  homePeriods: null,
};

export default QuarterSummary;



// WEBPACK FOOTER //
// ./src/QuarterSummary.js